export default "__VITE_PUBLIC_ASSET__6efd8f10__"